import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { toast } from "@/components/ui/sonner";

function messageOf(error: unknown): string {
  if (isAxiosError(error)) {
    const data = error.response?.data as { message?: string } | undefined;
    if (data?.message) return data.message;
    if (error.response?.status) return `Erro ${error.response.status} ao comunicar com o servidor.`;
  }
  return "Ocorreu um erro inesperado.";
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      // Paridade com o legado: PaginationService nunca refaz a busca ao focar
      // a aba de volta.
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isAxiosError(error) && [400, 401, 403, 404].includes(error.response?.status ?? 0)) return false;
        return failureCount < 1;
      },
    },
    mutations: { retry: 0 },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      // 401 é problema do api/client.ts (refresh/logout) — não duplicar o aviso.
      if (isAxiosError(error) && error.response?.status === 401) return;
      if (query.meta?.silent) return;
      toast.error(messageOf(error));
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (isAxiosError(error) && error.response?.status === 401) return;
      // Telas que mostram o erro no próprio conteúdo (ex.: chat do agente).
      if (mutation.meta?.silent) return;
      toast.error(messageOf(error));
    },
  }),
});
